<mat-radio-button [ngClass]="[sizeClass(), borderClass(), disabledClass()]" [disabled]="disabled()" [value]="value()">
  <div class="flex flex-col">
    <div class="flex items-center gap-1">
      <span class="ui-radio-button-label text-base font-medium">{{ label() }}</span>
      @if (tooltip()) {
        <ui-icon
          [matTooltip]="tooltipText()"
          (click)="handleTooltipIconClick($event)"
          class="text-gray-400"
          icon="griddy-info-circle"
          [size]="16"></ui-icon>
      }
      @if (hasBadge()) {
        <ng-content select="ui-badge"></ng-content>
      }
    </div>
    @if (description()) {
      <span class="text-sm text-text-tertiary font-normal">{{ description() }}</span>
    }
  </div>
</mat-radio-button>
